import { useTranslation } from 'react-i18next'
import { Box, Skeleton, Text } from '@mantine/core'

import classes from '../Campaign.module.scss'

import type { CampaignFundraisersProps } from './CampaignFundraisers.types'
import { FundraiserCard } from '@percent/workplace-giving/common/components/FundraiserCard/FundraiserCard'
import { FundraiserCardSkeleton } from '@percent/workplace-giving/common/components/FundraiserCard/FundraiserCardSkeleton'

export function CampaignFundraisers({ campaignId, data, isFetching }: CampaignFundraisersProps) {
  const { t } = useTranslation()

  if (isFetching) {
    return (
      <Box className={classes.SectionWrapper} data-testid="campaign-fundraisers-section-loader">
        <Skeleton height="2rem" width="55%" />
        <Box className={classes.SectionTilesContentWrapper}>
          <FundraiserCardSkeleton />
        </Box>
      </Box>
    )
  }

  if (!data?.pages?.[0]?.length) {
    return null
  }

  return (
    <Box className={classes.SectionWrapper} data-testid="campaign-fundraisers-section">
      <Text className={classes.SectionTitle}>{t('workplace_giving.campaigns.fundraisers')}</Text>
      <Box className={classes.SectionTilesContentWrapper}>
        {data.pages.map(p =>
          p.map(f => (
            <FundraiserCard key={f.id} fundraiser={f} linkAdditionalParams={new URLSearchParams({ campaignId })} />
          ))
        )}
      </Box>
    </Box>
  )
}
